module.exports = __webpack_public_path__ + "static/media/AB_angel_white_desktop.50b30e51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_angel_white_desktop.png
// module id = 590
// module chunks = 0